(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-cart-form]');
    if (!form) return;

    function updateShippingBar(cart) {
      const wrapper = document.querySelector('[data-shipping-progress]');
      if (!wrapper) return;
      const thresholdCents = Number(wrapper.dataset.threshold || 0);
      if (!thresholdCents) return;

      const remaining = Math.max(thresholdCents - cart.total_price, 0);
      const percent = Math.min((cart.total_price / thresholdCents) * 100, 100);
      const fill = wrapper.querySelector('[data-shipping-fill]');
      const text = wrapper.querySelector('[data-shipping-text]');
      if (fill) fill.style.width = percent + '%';
      if (text) {
        if (remaining > 0) {
          text.textContent = wrapper.dataset.template.replace('{amount}', formatMoney(remaining));
          text.classList.remove('cart-footer__shipping-text--met');
        } else {
          text.textContent = wrapper.dataset.metText;
          text.classList.add('cart-footer__shipping-text--met');
        }
      }
    }

    function formatMoney(cents) {
      // Matches the store's money_format ("€1.234,56") rather than relying on
      // Intl/browser locale, which produced a different decimal separator
      // than the server-rendered amounts.
      const amount = (cents / 100).toFixed(2);
      const [whole, decimals] = amount.split('.');
      const wholeWithDots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + wholeWithDots + ',' + decimals;
    }

    async function changeLine(key, quantity) {
      const variantId = key.split(':')[0];
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      const cart = await response.json();

      if (!response.ok || !cart.items) {
        console.error('Cart update failed', response.status, cart);
        return;
      }

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      const row = form.querySelector('[data-cart-key="' + key + '"]');
      // Match by variant id rather than the full key: Shopify regenerates the
      // properties-hash portion of item.key on every mutation on this store,
      // so comparing the full key against the one we sent would always miss.
      const updatedItem = cart.items.find((item) => item.key.split(':')[0] === variantId);

      if (quantity === 0 || !updatedItem) {
        row?.remove();
      } else if (row) {
        row.dataset.cartKey = updatedItem.key;
        const lineTotal = row.querySelector('[data-line-total]');
        const input = row.querySelector('[data-quantity-input]');
        if (lineTotal) lineTotal.textContent = formatMoney(updatedItem.final_line_price);
        if (input) input.value = updatedItem.quantity;
      }

      const subtotal = form.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      updateShippingBar(cart);
    }

    form.addEventListener('click', (event) => {
      const row = event.target.closest('[data-cart-item]');
      if (!row) return;
      const key = row.dataset.cartKey;
      const input = row.querySelector('[data-quantity-input]');

      if (event.target.closest('[data-quantity-increase]')) {
        event.preventDefault();
        changeLine(key, Number(input.value) + 1);
      } else if (event.target.closest('[data-quantity-decrease]')) {
        event.preventDefault();
        const next = Math.max(Number(input.value) - 1, 0);
        changeLine(key, next);
      } else if (event.target.closest('[data-cart-remove]')) {
        event.preventDefault();
        changeLine(key, 0);
      }
    });

    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-quantity-input]')) return;
      const row = event.target.closest('[data-cart-item]');
      const key = row?.dataset.cartKey;
      const quantity = Math.max(Number(event.target.value) || 0, 0);
      if (key) changeLine(key, quantity);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-usp-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.usp-bar').forEach((root) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const viewport = root.querySelector('[data-usp-viewport]');
    const track = root.querySelector('[data-usp-track]');
    const dotsContainer = root.querySelector('[data-usp-dots]');
    if (!viewport || !track || !dotsContainer) return;

    const slides = Array.from(track.children);
    if (slides.length < 2) return;

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'usp-bar__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });
    const dots = Array.from(dotsContainer.children);

    function scrollToSlide(slide) {
      viewport.scrollLeft = slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
    }

    function updateActiveDot() {
      const viewportRect = viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
      return closestIndex;
    }

    // Guards the auto-advance's own programmatic scroll so the scroll
    // listener below doesn't mistake it for manual interaction and reset
    // its own timer.
    let isProgrammaticScroll = false;

    function goToSlide(index) {
      isProgrammaticScroll = true;
      scrollToSlide(slides[index]);
      window.setTimeout(() => {
        isProgrammaticScroll = false;
      }, 500);
    }

    let autoAdvanceTimer;
    function startAutoAdvance() {
      clearInterval(autoAdvanceTimer);
      autoAdvanceTimer = setInterval(() => {
        const currentIndex = updateActiveDot();
        goToSlide((currentIndex + 1) % slides.length);
      }, 5000);
    }

    viewport.addEventListener(
      'scroll',
      () => {
        updateActiveDot();
        if (isProgrammaticScroll) return;
        startAutoAdvance();
      },
      { passive: true }
    );

    updateActiveDot();
    startAutoAdvance();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('.header__drawer-toggle');
      this.closeButton = this.querySelector('.header__drawer-close');
      this.backdrop = this.querySelector('.header__drawer-backdrop');

      this.toggle.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      this.closeButton.focus();
    }

    close() {
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.toggle.focus();
    }
  }

  customElements.define('header-drawer', HeaderDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function setActiveMedia(mediaRoot, mediaId) {
    if (!mediaRoot || !mediaId) return;
    const scroller = mediaRoot.querySelector('[data-media-main]');
    const item = scroller ? scroller.querySelector(`[data-media-id="${mediaId}"]`) : null;
    if (item) {
      // A plain scrollLeft assignment is used instead of scrollIntoView()/scrollTo()
      // with smooth behavior: combined with scroll-snap-type, smooth programmatic
      // scrolling does not reliably animate the container in every browser.
      scroller.scrollLeft = item.offsetLeft;
    }
    mediaRoot.querySelectorAll('[data-media-thumbnail]').forEach((thumb) => {
      thumb.classList.toggle('is-selected', thumb.getAttribute('data-media-id') === String(mediaId));
    });
  }

  document.querySelectorAll('.product__media').forEach((mediaRoot) => {
    const scroller = mediaRoot.querySelector('[data-media-main]');
    const thumbnails = mediaRoot.querySelectorAll('[data-media-thumbnail]');
    if (!scroller || !thumbnails.length) return;

    // Keeps the thumbnail highlight in sync when the shopper swipes the
    // gallery by hand instead of clicking a thumbnail.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.getAttribute('data-media-id');
          thumbnails.forEach((thumb) => {
            thumb.classList.toggle('is-selected', thumb.getAttribute('data-media-id') === id);
          });
        });
      },
      { root: scroller, threshold: 0.6 }
    );
    scroller.querySelectorAll('[data-media-item]').forEach((item) => observer.observe(item));
  });

  function applyVariantFromSelection(form) {
    const selected = {};
    form.querySelectorAll('.is-selected[data-option-position]').forEach((control) => {
      selected[control.getAttribute('data-option-position')] = control.getAttribute('data-option-value');
    });

    const variantsScript = form.querySelector('[data-product-variants]');
    const variantsData = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const matchedVariant = variantsData.find((variant) =>
      Object.keys(selected).every((position) => variant['option' + position] === selected[position])
    );
    if (!matchedVariant) return;

    form.querySelector('[data-variant-id-input]').value = matchedVariant.id;

    const infoColumn = form.closest('.product__info') || form;
    infoColumn.querySelectorAll('[data-variant-price]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-variant-id') !== String(matchedVariant.id);
    });

    const meta = form.querySelector(`[data-variant-meta][data-variant-id="${matchedVariant.id}"]`);
    const submitButton = form.querySelector('[data-add-to-cart]');
    const isAvailable = meta ? meta.getAttribute('data-available') === 'true' : false;
    submitButton.disabled = !isAvailable;
    submitButton.textContent = isAvailable
      ? submitButton.getAttribute('data-add-text')
      : submitButton.getAttribute('data-sold-out-text');

    const mediaId = meta ? meta.getAttribute('data-featured-media-id') : '';
    const mediaRoot = document.querySelector('.product__media');
    if (mediaId) setActiveMedia(mediaRoot, mediaId);
  }

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-media-thumbnail]');
    if (thumbnail) {
      setActiveMedia(thumbnail.closest('.product__media'), thumbnail.getAttribute('data-media-id'));
      return;
    }

    const optionControl = event.target.closest('[data-option-value]');
    if (!optionControl) return;

    const form = optionControl.closest('[data-product-form]');
    if (!form) return;

    const group = optionControl.closest('.product-form__swatches, .product-form__size-buttons');
    group.querySelectorAll('[data-option-value]').forEach((control) => {
      control.classList.remove('is-selected');
      control.setAttribute('aria-pressed', 'false');
    });
    optionControl.classList.add('is-selected');
    optionControl.setAttribute('aria-pressed', 'true');

    // Keep the hidden native input (read by Swatch King) in sync with the
    // custom swatch button that was actually clicked.
    if (group.classList.contains('product-form__swatches')) {
      const value = optionControl.getAttribute('data-option-value');
      group.querySelectorAll('input.visually-hidden-swatch-input').forEach((input) => {
        input.checked = input.value === value;
      });
    }

    applyVariantFromSelection(form);
  });

  // Swatch King drives color selection through the hidden native inputs
  // (per their support's integration guidance): when it checks one and
  // fires a change event, mirror that back onto our own swatch buttons
  // and re-run the same variant/image/price update the click handler uses.
  document.addEventListener('change', (event) => {
    const hiddenInput = event.target.closest('input.visually-hidden-swatch-input');
    if (!hiddenInput || !hiddenInput.checked) return;

    const form = hiddenInput.closest('[data-product-form]');
    const group = hiddenInput.closest('.product-form__swatches');
    if (!form || !group) return;

    group.querySelectorAll('.product-form__swatch').forEach((button) => {
      const isMatch = button.getAttribute('data-option-value') === hiddenInput.value;
      button.classList.toggle('is-selected', isMatch);
      button.setAttribute('aria-pressed', String(isMatch));
    });

    applyVariantFromSelection(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();

    const submitButton = form.querySelector('[data-add-to-cart]');
    const message = form.querySelector('[data-cart-message]');
    const addingText = submitButton.getAttribute('data-adding-text');
    const addText = submitButton.getAttribute('data-add-text');

    submitButton.disabled = true;
    submitButton.textContent = addingText;
    message.removeAttribute('data-state');
    message.textContent = '';

    fetch(`${form.dataset.cartAddUrl}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          message.setAttribute('data-state', 'error');
          message.textContent = data.description || data.message;
          return;
        }

        return fetch(`${form.dataset.cartUrl}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const cartLink = document.querySelector(`a[href="${form.dataset.cartUrl}"]`);
            if (!cartLink) return;
            let badge = cartLink.querySelector('sup');
            if (!badge) {
              badge = document.createElement('sup');
              cartLink.prepend(badge);
            }
            badge.textContent = cart.item_count;
          });
      })
      .catch(() => {
        message.setAttribute('data-state', 'error');
      })
      .finally(() => {
        submitButton.disabled = false;
        submitButton.textContent = addText;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  function getCarouselParts(root) {
    return {
      viewport: root.querySelector('[data-carousel-viewport]'),
      slides: Array.from(root.querySelectorAll('[data-carousel-slide]')),
      dots: Array.from(root.querySelectorAll('[data-carousel-dot]')),
    };
  }

  function scrollToSlide(viewport, slide) {
    if (!viewport || !slide) return;
    // A plain scrollLeft assignment is used instead of scrollIntoView()/scrollTo()
    // with smooth behavior: combined with scroll-snap-type, smooth programmatic
    // scrolling does not reliably animate the container in every browser.
    viewport.scrollLeft = slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
  }

  function updateActiveSlide(root) {
    const { viewport, slides, dots } = getCarouselParts(root);
    if (!viewport || !slides.length) return;

    const viewportRect = viewport.getBoundingClientRect();
    const viewportCenter = viewportRect.left + viewportRect.width / 2;

    let closestSlide = slides[0];
    let closestDistance = Infinity;
    slides.forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const slideCenter = rect.left + rect.width / 2;
      const distance = Math.abs(slideCenter - viewportCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = slide;
      }
    });

    const activeIndex = slides.indexOf(closestSlide);
    slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === activeIndex);
    });
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  document.querySelectorAll('.reviews-carousel').forEach((root) => {
    const { viewport, slides } = getCarouselParts(root);
    if (!viewport || !slides.length) return;

    updateActiveSlide(root);

    // Not throttled through requestAnimationFrame: rAF is fully suspended on
    // hidden/background tabs, which would leave the active-slide highlight
    // stuck. The per-slide center-distance check below is cheap enough
    // (at most 10 slides) to run on every scroll event directly.
    viewport.addEventListener('scroll', () => updateActiveSlide(root), { passive: true });

    window.addEventListener('resize', () => updateActiveSlide(root));

    const prevButton = root.querySelector('[data-carousel-prev]');
    const nextButton = root.querySelector('[data-carousel-next]');
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const targetIndex = Math.max(activeIndex - 1, 0);
        scrollToSlide(viewport, slides[targetIndex]);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const targetIndex = Math.min(activeIndex + 1, slides.length - 1);
        scrollToSlide(viewport, slides[targetIndex]);
      });
    }

    root.querySelectorAll('[data-carousel-dot]').forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.getAttribute('data-index'));
        scrollToSlide(viewport, slides[index]);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
